<!--<ipos-sidebar></ipos-sidebar>-->
<article>
    <div class="header bg-white">
        <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-3 bg-head-light mb-2">
                    <div class="col-lg-6 col-5">
                        <h1 style="justify-content: center;" class="h3 mb-0">Request for Replacement</h1>
                        <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                            <ol class="breadcrumb breadcrumb-links breadcrumb-dark mt-2">
                                <li class="breadcrumb-item">
                                    <i class="fas fa-home"></i>
                                </li>
                                <li class="breadcrumb-item"><a routerLink="/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    Request for Reconfigure
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div class="col-lg-6 col-7 text-right">
                        <div class="quick-filter">
                            <input type="text" (keyup)="onQuickFilterChanged()" class="form-control"
                                   [(ngModel)]="quickSearchValue" placeholder="search..." /><i class="fa fa-search"></i>
                          </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="p-3 removal-list">
        <ag-grid-angular style=" height: 72vh;" class="ag-theme-balham" [enableSorting]="true" [enableCellTextSelection]="true" [enableFilter]="true" [rowData]="rows" [pagination]="true" [rowHeight]="40" [columnDefs]="columnDefs" (modelUpdated)="onModelUpdated()"
            (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)">
        </ag-grid-angular>
    </div>




</article>
<div class="modal" id="myModal" [style.display]="showModelBox ? 'block' : 'none'">
    <div class="modal-dialog modal-lg" style="height: 500px  !important;">
        <div class="modal-content">
            <div class="modal-header" style="background-color: #7146EB !important;color:white">
                <h3 style="text-align:center !important; color:white;">Reconfigure Request</h3>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()"><i class="fa fa-times"></i></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="reconfigureForm" (ngSubmit)="saveReconfigure()">
                    <div class="row">

                        <div class="form-group col-md-4">
                            <label class="col-md-6"> Merchant</label>
                            <p>{{editRow.merchant}}</p>
                        </div>

                        <div class="form-group col-md-4">
                            <label class="col-md-6">Merchant Id</label>
                            <p>{{idMer}}</p>
                        </div>
                        <div class="form-group col-md-4">
                            <label class="col-md-6">Terminal Id</label>
                            <p>{{idTer}}</p>
                        </div>
                    </div>
                    <p>Please , Provide details for reconfigure of the above mentioned Merchant </p>
                    <div class="row">

                        <div class="form-group col-md-6">

                            <label class="col-lg-8"> Component 1 <sup class="required-sign">*</sup></label>
                            <input type="text" class="form-control col-sm-12" id="component1" name="component1" formControlName="component1" [ngClass]="{ 'is-invalid': submitted && f.component1.errors }" [(ngModel)]="historyEdit.component1" placeholder="Component 1">
                            <div *ngIf="submitted && f.component1.errors" class="invalid-feedback">
                                <div *ngIf="f.component1.errors.required">Component 1 is required</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">

                            <label class="col-lg-8"> Key Value 1 <sup class="required-sign">*</sup></label>
                            <input type="text" class="form-control col-sm-12" id="kvc1" name="kvc1" formControlName="kvc1" [ngClass]="{ 'is-invalid': submitted && f.kvc1.errors }" [(ngModel)]="historyEdit.kvc1" placeholder="Key value 1">
                            <div *ngIf="submitted && f.kvc1.errors" class="invalid-feedback">
                                <div *ngIf="f.kvc1.errors.required">Key Value 1 is required</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">

                            <label class="col-lg-8"> Component 2 <sup class="required-sign">*</sup></label>
                            <input type="text" class="form-control col-sm-12" id="component2" name="component2" formControlName="component2" [ngClass]="{ 'is-invalid': submitted && f.component2.errors }" [(ngModel)]="historyEdit.component2" placeholder="Component 2">
                            <div *ngIf="submitted && f.component2.errors" class="invalid-feedback">
                                <div *ngIf="f.component2.errors.required">Component 2 is required</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">

                            <label class="col-lg-8"> Key Value 2 <sup class="required-sign">*</sup></label>
                            <input type="text" class="form-control col-sm-12" id="kvc2" name="kvc2" formControlName="kvc2" [ngClass]="{ 'is-invalid': submitted && f.kvc2.errors }" [(ngModel)]="historyEdit.kvc2" placeholder="Key value 2">
                            <div *ngIf="submitted && f.kvc2.errors" class="invalid-feedback">
                                <div *ngIf="f.kvc2.errors.required"> Key Value 2 is required</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">

                            <label class="col-lg-8"> Combine Value</label>
                            <input type="text" class="form-control col-sm-12" id="combineValue" name="combineValue" formControlName="combineValue" [(ngModel)]="historyEdit.combineValue" placeholder="Combine Value">

                        </div>
                        <div class="form-group col-md-6">

                            <label class="col-lg-8">Final Value <sup class="required-sign">*</sup></label>
                            <input type="text" class="form-control col-sm-12" id="finalValue" name="finalValue" formControlName="finalValue" [ngClass]="{ 'is-invalid': submitted && f.finalValue.errors }" [(ngModel)]="historyEdit.finalValue" placeholder="Final Value">
                            <div *ngIf="submitted && f.finalValue.errors" class="invalid-feedback">
                                <div *ngIf="f.finalValue.errors.required">Final Value is required</div>
                            </div>
                        </div>


                        <div class="form-group col-md-6">

                            <label class="col-lg-8"> Replace Terminal Type<sup class="required-sign">*</sup></label>
                            <input type="text" class="form-control col-sm-12" id="terminalType" name="terminalType" formControlName="terminalType" [ngClass]="{ 'is-invalid': submitted && f.terminalType.errors }" [(ngModel)]="historyEdit.terminalType" placeholder="terminalType">
                            <div *ngIf="submitted && f.terminalType.errors" class="invalid-feedback">
                                <div *ngIf="f.terminalType.errors.required">Terminal Type is required</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">

                            <label class="col-lg-8">Remarks for Replace<sup class="required-sign">*</sup></label>
                            <input type="text" class="form-control col-sm-12" id="remarksDeploy" name="remarksDeploy" formControlName="remarksDeploy" [ngClass]="{ 'is-invalid': submitted && f.remarksDeploy.errors }" [(ngModel)]="historyEdit.remarksDeploy" placeholder="Replace remarks">
                            <div *ngIf="submitted && f.remarksDeploy.errors" class="invalid-feedback">
                                <div *ngIf="f.remarksDeploy.errors.required"> Reason for replace is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">

                        <button *ngIf="!isReqSave" class="btn btn-neutral" type="submit" style=" margin: 0 auto;">
                      <span  class="spinner-border spinner-border-sm mr-1"></span>
                        Submit Request
                    </button>
                        <button *ngIf="isReqSave" color="success" [disabled]="isReqSave" class="btn btn-warning" style="font-size: 13px; float: right; width: auto;margin: 7px auto; border-radius: 30px">Submitting
                     Request...
                    </button>
                        <!-- <button *ngIf="!isReqSave" color="success" (click)="SubmitDeploymentRequest()" class="btn btn-success"
              style="font-size: 13px; float: center; width: auto;margin: 7px auto; border-radius: 30px">Submit Request
            </button>
            <button *ngIf="isReqSave" color="success" [disabled]="loading" class="btn btn-warning"
              style="font-size: 13px; float: right; width: auto;margin: 7px auto; border-radius: 30px">Submitting
              Request </button> -->

                    </div>



                </form>
            </div>

        </div>
    </div>
</div>